function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import split from 'lodash/split';
import some from 'lodash/some';
import unset from 'lodash/unset';
import forEach from 'lodash/forEach';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import filter from 'lodash/filter';
import find from 'lodash/find';
import { useAction, useProgressSuccess } from 'hooks';
import App from 'modules/App';
import Information from 'modules/Information';
import { pickLegalConsents } from '../../helpers';
import { SIGN_UP_FORM } from '../../../../constants';
import { useIsMinor } from '../hooks';
const useConsentsEffects = (stepValidatorRules, setStepValidatorRules)=>{
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const isFetchConsentsTemplateInProgress = useSelector(Information.selectors.isFetchConsentsTemplateInProgress);
    const hasErrors = useSelector(Information.selectors.hasFetchConsentsTemplateErrors);
    const setFormValues = useAction(App.actions.setFormValues, SIGN_UP_FORM);
    const unsetFormValues = useAction(App.actions.unsetFormValues, SIGN_UP_FORM);
    const isMinor = useIsMinor();
    const termsOfService = filter(consentsTemplate, (consent)=>consent.type === 'TermsOfService');
    const initialCurrentConsents = (implicityApproveMandatory = false)=>{
        const legalConsentFieldIds = [];
        const newValidatorRules = {};
        forEach(termsOfService, (legalConsent)=>{
            const { legalConsentId, isMandatory } = legalConsent;
            const legalConsentFieldId = `legalConsent-${legalConsentId}`;
            legalConsentFieldIds.push(legalConsentFieldId);
            newValidatorRules[legalConsentFieldId] = isMandatory ? 'required, bool' : 'bool';
        });
        setStepValidatorRules((prevState)=>_object_spread({}, prevState, newValidatorRules));
        if (legalConsentFieldIds.length) {
            const legalConsentsForm = {};
            legalConsentFieldIds.forEach((legalConsentFieldId)=>{
                if (!implicityApproveMandatory) {
                    legalConsentsForm[legalConsentFieldId] = '';
                } else {
                    const result = split(legalConsentFieldId, '-');
                    const legalConsentId = Number(result[1]);
                    const term = find(termsOfService, {
                        legalConsentId
                    });
                    legalConsentsForm[legalConsentFieldId] = term.isMandatory ? 'true' : '';
                }
            });
            setFormValues(legalConsentsForm);
        }
    };
    const removePreviousConsents = ()=>{
        const legalConsentsFormValues = pickLegalConsents(formValues.values);
        const prevMandatoryConsents = _object_spread({}, pickLegalConsents(stepValidatorRules), legalConsentsFormValues);
        setStepValidatorRules((prevState)=>{
            const newState = _object_spread({}, prevState);
            forEach(prevMandatoryConsents, (value, key)=>{
                unset(newState, key);
            });
            return newState;
        });
        const legalConsentsToUnset = [];
        forEach(legalConsentsFormValues, (value, key)=>{
            const id = parseInt(split(key, '-')[1], 10);
            if (isMinor || !some(termsOfService, {
                legalConsentId: id
            })) {
                legalConsentsToUnset.push(key);
            }
        });
        if (legalConsentsToUnset.length > 0) {
            unsetFormValues(legalConsentsToUnset);
        }
    };
    const updateConsents = ()=>{
        removePreviousConsents();
        initialCurrentConsents(isMinor);
    };
    useEffect(()=>{
        removePreviousConsents();
        initialCurrentConsents(isMinor);
    }, []);
    useProgressSuccess(isFetchConsentsTemplateInProgress, hasErrors, updateConsents);
};
export default useConsentsEffects;
